import React,{useState, useEffect} from 'react'
import { getToken } from '../../api/auth';
import { Container, TextField, Button } from '@mui/material'
import { useDispatch } from 'react-redux'
import { NavLink, useHistory } from "react-router-dom";
import { logIn } from '../../store/reducers/authReducer';
import '../../styles/LoginAndUserSelect.css'

export default function Login(props) {

    const history = useHistory()
    if(props.location.userType===undefined){
        history.push('/userSelect')
    }

    const dispatch = useDispatch()

    const [email, setEmail] = useState(null)
    const [password, setPassword] = useState(null)
    const [error, setError] = useState(null)

    const login = (email, password) => {
        getToken(email, password).then(result=>{
            console.log(result)
            if(result.error){
                console.log(result.error)
                setError("Error: " + result.error)
                return
            }
            localStorage.setItem('accessToken' , result.access)
            localStorage.setItem('userType' , result.user_type)
            dispatch(logIn({accessToken: result.access, userType: result.user_type}))
            history.push('/')
        })    
    }

    return (
        <div className=''>
            <Container>
                <div className="loginFormParent">
                    <div className="centerText" 
                        style={{textTransform: "capitalize", marginBottom: "20px", 
                        fontSize: "2.5rem", fontWeight:600}}
                    >
                        {props.location.userType} Login
                    </div>
                    {error === null ? null : (
                        <div className='authFormErrorSection'>
                            {error}
                        </div>
                    )}
                    <div className="centerDiv loginFormFields">
                        <TextField
                        onChange={(e)=>{setEmail(e.target.value)}}
                        id="outlined-basic" label="Email ID" variant="outlined" fullWidth/>
                    </div>
                    <div className="centerDiv loginFormFields">
                        <TextField
                        type={"password"}
                        onChange={(e)=>{setPassword(e.target.value)}}
                        id="outlined-basic" label="Password" variant="outlined" fullWidth/>
                    </div>
                    <div className="centerDiv loginButton">
                        <Button variant="contained" className="loginButton" onClick={()=>{login(email, password)}}>
                            Login
                        </Button>
                    </div>
                    <NavLink to={{pathname: "/register", userType: props.location.userType}}>
                        <div className="centerText" style={{marginTop:"5px", color: "darkblue"}}>
                            Don't have an account? Register
                        </div>
                    </NavLink>
                </div>
            </Container>
        </div>
    )
}